module.exports = __webpack_public_path__ + "static/media/external-link.ec94d76b.svg";